import mapboxgl from "mapbox-gl";

(function () {
    'use strict';

    var geojson = {};
    var map;
    var isTouchDevice = false;

    function hotelOverviewMapboxInit() {

        mapboxgl.accessToken = 'pk.eyJ1IjoiYXBleGhvdGVscyIsImEiOiJja2RhMXRpNjkwamRhMnNtaWw0NzZiZzZiIn0.a9_d3rrQoG-B16n3eK4T2Q';

        var strtLatlng = [-0.696796, 54.409898];

        map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/apexhotels/ckda2jofm0szg1ipgsb5nsjrq',
            center: strtLatlng,
            zoom: 4,
            attributionControl: false
        });

        map.addControl(new mapboxgl.AttributionControl(), 'top-left');

        map.on('load', function () {
            hotelOverviewLocationsMapboxCreateGeoJSON();
            hotelOverviewSetInitialPosition();
        });
    }

    // On Mapbox there is no click listener available for the markers. This can be accomplished using the GeoJSON markup they use.
    function hotelOverviewLocationsMapboxCreateGeoJSON() {
        // create the initial structure
        geojson = {
            type: 'FeatureCollection',
            features: []
        };

        // Add Hotels
        document.querySelectorAll('.js-hotel-card').forEach(function (hotel) {
            var dataContentID = hotel.dataset.contentId;
            var longitude = parseFloat(hotel.dataset.lng);
            var latitude = parseFloat(hotel.dataset.lat);
            var markerCount = parseInt(hotel.dataset.markerCount);

            var marker = {
                'type': 'Feature',
                'properties': {
                    'markerType': 'hotel',
                    'markerCount': markerCount,
                    'selector': '.hotel-card[data-content-id="' + dataContentID + '"]'
                },
                'geometry': {
                    'type': 'Point',
                    'coordinates': [longitude, latitude]
                }
            };

            geojson.features.push(marker);
        });

        // add markers to map
        geojson.features.forEach(function (marker) {

            // create a DOM element for the marker
            var el = document.createElement('div');

            el.innerHTML = '<div class="marker-template" data-marker-count="' + marker.properties.markerCount + '"><em class="fas fa-map-marker"></em><span>' + marker.properties.markerCount + '</span></div>';

            el.className = marker.properties.markerType + '-marker';
            el.addEventListener('click', function () {
                var target = document.querySelector(marker.properties.selector);
                if (target) ShowCard(target);
            });

            // add marker to map
            new mapboxgl.Marker(el)
                .setLngLat(marker.geometry.coordinates)
                .addTo(map);
        });

        map.on('zoom', function () {
            hotelOverviewLocationsMapboxZoomChange(map);
        });
        hotelOverviewLocationsMapboxZoomChange(map);
    }

    function hotelOverviewLocationsMapboxZoomChange(mapInstance) {
        var zoomLevel = mapInstance.getZoom();
        if (zoomLevel >= 10) {
            document.querySelectorAll('.map-tile .hotel-marker').forEach(function (el) { el.classList.remove('hidden-marker'); });
        } else {
            document.querySelectorAll('.map-tile .hotel-marker').forEach(function (el) { el.classList.add('hidden-marker'); });
        }
    }

    function hotelOverviewSetInitialPosition() {
        // multiple hotels
        var northPosition = -Infinity, eastPosition = -Infinity, southPosition = Infinity, westPosition = Infinity;

        document.querySelectorAll('.hotel-card').forEach(function (destination) {
            var latitude = parseFloat(destination.dataset.lat);
            var longitude = parseFloat(destination.dataset.lng);

            if (!isNaN(latitude)) {
                northPosition = Math.max(latitude, northPosition);
                southPosition = Math.min(latitude, southPosition);
            }
            if (!isNaN(longitude)) {
                eastPosition = Math.max(longitude, eastPosition);
                westPosition = Math.min(longitude, westPosition);
            }
        });

        if (document.querySelectorAll('.hotel-card').length === 1) {
            var longitude = parseFloat(document.querySelector('.hotel-card').dataset.lng);
            var latitude = parseFloat(document.querySelector('.hotel-card').dataset.lat);

            map.flyTo({ center: [longitude, latitude], zoom: 13 });
        }
        else if (westPosition !== Infinity && southPosition !== Infinity && eastPosition !== -Infinity && northPosition !== -Infinity) {
            var bounds = new mapboxgl.LngLatBounds(
                new mapboxgl.LngLat(westPosition, southPosition),
                new mapboxgl.LngLat(eastPosition, northPosition)
            );

            map.fitBounds(bounds, { padding: 100 });
        }
    }

    function hotelOverviewResizeMapMenu() {
        if (window.innerWidth < 768) {
            var activeItem = document.querySelector('.map-menu-container.active');
            if (activeItem) {
                var parent = activeItem.closest('.map-list-items');
                if (parent) parent.style.height = activeItem.offsetHeight + 'px';
            }
        } else {
            document.querySelectorAll('.map-list-items').forEach(function (el) { el.style.height = ''; });
        }
    }

    // I need a function that detects when .js-hotel-card reaches the top of the viewport.
    // This will then take the data marker count number and find the corresponding marker
    // on the map and add a class to .marker-template called current-hotel. The function
    // will also remove the class from any other .marker-template that has it.
    // Call: initHotelCardTopWatcher({ offset: 0, threshold: 30 });
    // offset = pixels from viewport top (use header height if needed).
    // threshold = how close to the top (in px) we consider "reached the top".
    function initHotelCardTopWatcher(opts) {
        const options = Object.assign({ offset: 0, threshold: 30 }, opts || {});
        const cards = Array.from(document.querySelectorAll('.js-hotel-card'));
        if (!cards.length) return { destroy: () => {} };

        let ticking = false;

        function checkCards() {
            const offset = options.offset;
            const threshold = options.threshold;

            // Find the card whose top is closest to the `offset` and within viewport
            let best = null;
            let bestDist = Infinity;
            const vh = window.innerHeight || document.documentElement.clientHeight;

            for (const card of cards) {
                const rect = card.getBoundingClientRect();
                // Only consider cards that are at least partially visible
                if (rect.bottom < 0 || rect.top > vh) continue;
                const dist = Math.abs(rect.top - offset);
                if (dist < bestDist) {
                    bestDist = dist;
                    best = card;
                }
            }

            if (best && bestDist <= threshold) {
                const markerCount = best.dataset.markerCount;
                if (markerCount !== undefined) {
                    // remove class from any other marker-template
                    document.querySelectorAll('.marker-template.current-hotel').forEach(el => el.classList.remove('current-hotel'));
                    const marker = document.querySelector('.marker-template[data-marker-count="' + markerCount + '"]');
                    if (marker) marker.classList.add('current-hotel');
                }
            }
        }

        function onScroll() {
            if (!ticking) {
                ticking = true;
                requestAnimationFrame(() => {
                    checkCards();
                    ticking = false;
                });
            }
        }

        // initial check
        checkCards();

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);

        return {
            destroy() {
                window.removeEventListener('scroll', onScroll);
                window.removeEventListener('resize', onScroll);
            }
        };
    }

    document.addEventListener('DOMContentLoaded', function () {
        hotelOverviewMapboxInit();



        //mobile vars
        isTouchDevice = ('ontouchstart' in document.documentElement);

        // By default we need to set the height of the container
        hotelOverviewResizeMapMenu();

        window.addEventListener('resize', function () {
            hotelOverviewResizeMapMenu();
        });

        const watcher = initHotelCardTopWatcher({ offset: 80, threshold: 20 });
    });



})();
